import type { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import theme from '@/theme';

declare type TextType = 'primary' | 'secondary' | 'danger';

export interface TextProps extends Pick<CSSProperties, 'whiteSpace' | 'fontWeight'> {
  color?: string;
  type?: TextType;
  size?: CSSProperties['fontSize'];
  muted?: boolean;
  /**
   * @deprecated Use `fontWeight` instead
   */
  bold?: boolean;
  align?: CSSProperties['textAlign'];
}

const {
  colors: { themePrimary, neutralDark, themeError },
} = theme;

const colors = {
  primary: themePrimary,
  secondary: theme.color.grey.grey6,
  danger: themeError,
};

/**
 * @deprecated Use `Typography` instead.
 */
export const Text = styled.span<TextProps>`
  color: ${({ type, color }) => {
    if (color) {
      return color;
    }
    if (type) {
      return colors[type];
    }
    return neutralDark;
  }};

  ${({ align }) =>
    align &&
    css`
      display: block;
      text-align: ${align};
    `}

  ${({ size }) =>
    size &&
    css`
      font-size: ${size};
    `};

  ${({ muted }) =>
    muted &&
    css`
      opacity: 0.7;
    `};

  ${({ bold, fontWeight }) =>
    (bold || Boolean(fontWeight)) &&
    css`
      font-weight: ${fontWeight ?? 700};
    `};

  ${({ whiteSpace }) =>
    whiteSpace &&
    css`
      white-space: ${whiteSpace};
    `}
`;
